import React from "react";
import { withNamespaces } from 'react-i18next';

const Preparar = ({ t }) => {
  return (
    <>
      <div className="container">
        {/* AREA 1 DECLARAÇÃO DE MATRÍCULA */}
        <div id="1" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('modulePrepararViagem:S1.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S1.P1') }}>
            </p>
          </div>
        </div>
        {/* AREA 2 VISTO DE ESTUDO */}
        <div id="2" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('modulePrepararViagem:S2.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S2.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S2.P2') }}>
            </p>
          </div>
        </div>
        {/* AREA 3 DOCUMENTOS NECESSÁRIOS */}
        <div id="3" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('modulePrepararViagem:S3.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next">
              {t('modulePrepararViagem:S3.P1')}
            </p>
            <ul className="bulletpoint lista">
              <li>{t('modulePrepararViagem:S3.UL.LI1')}</li>
              <li>{t('modulePrepararViagem:S3.UL.LI2')}</li>
              <li>{t('modulePrepararViagem:S3.UL.LI3')}</li>
              <li>{t('modulePrepararViagem:S3.UL.LI4')}</li>
            </ul>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S3.P2') }}>
            </p>
          </div>
        </div>
        {/* AREA 4 APOSTILA DE HAIA */}
        <div id="4" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('modulePrepararViagem:S4.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S4.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S4.P2') }}>
            </p>
            <p className="p_next">
              {t('modulePrepararViagem:S4.P3')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S4.P4') }}>
            </p>
          </div>
        </div>
        {/* AREA 5 PAGAMENTOS */}
        <div id="5" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('modulePrepararViagem:S5.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">

            <p className="p_next">
              <span dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S5.P1') }}>
              </span>
              <a className='link' href={t('modulePrepararViagem:S5.Link')} target='_blank' rel='noreferrer'>{t('modulePrepararViagem:S5.NameLink')}</a>
              <span dangerouslySetInnerHTML={{ __html: t('modulePrepararViagem:S5.P2') }}>
              </span>
            </p>
            <p>
              {t('modulePrepararViagem:S5.P3')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(Preparar);
